import(/* webpackMode: "eager" */ "/vercel/path0/apps/client/app/tools/page.tsx");
